import { Button } from "@/components/ui/button";
import { FlaskConical } from "lucide-react";

export function PreencherTesteButton({ onFill }: { onFill: () => void }) {
  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      className="h-7 text-xs gap-1.5 border-amber-300 text-amber-700 hover:bg-amber-50"
      onClick={onFill}
    >
      <FlaskConical className="w-3 h-3" />
      Preencher com dados de teste
    </Button>
  );
}
